// extracted by mini-css-extract-plugin
export default {"cabecalho":"Cabecalho_cabecalho__HMrxR","home":"Cabecalho_home__13vRD"};